<rid-sentence-reading-guided
  class="h-dvh"
  [sentencesMatrix]="[
    ['Er was eens een man met een plan.', 'Hij wilde vliegen.', 'Dus bouwde hij een vliegtuig.'],
    ['Er was eens een man met een plan.', 'Hij wilde vliegen.'],
  ]"
  [pace]="pace()"
  [mode]="mode()"
  (finished)="$router.navigate(['/mechanics/reading-basis'])"
/>
